module.exports = __webpack_public_path__ + "media/images/home/focus-bg1-132dff83ccd5ef66976ce70505ab2acd.png";